import React from 'react';
import { motion } from 'framer-motion';

function About({ backgroundinfo, profileurl }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1.5 }}
      className=" h-fit py-10 md:h-screen flex relative flex-col text-center items-center md:text-left md:flex-row max-w-7xl px-10 justify-evenly mx-auto"
    >
      <h3 className="absolute text-center top-0 uppercase tracking-[20px] text-gray-500">
        About
      </h3>
      <motion.img
        src={profileurl}
        initial={{
          opacity: 0,
          x: -200,
        }}
        transition={{ duration: 1.2 }}
        whileInView={{
          opacity: 1,
          x: 0,
        }}
        className=" rounded-full mb-11 sm:mb-0 object-cover h-56 w-56 flex-shrink-0 md:rounded-lg md:w-64 md:h-95 xl :h-[600px]"
      ></motion.img>
      <div className="space-y-10 px-0 md:px-10">
        <h4 className="tetx-4xl font-semibold">
          A Little{' '}
          <span className="underline decoration-[#5bccf6] ">Background</span>{' '}
          Information
        </h4>
        <p className="text-[10px] md:text-lg  text-black">{backgroundinfo}</p>
      </div>
    </motion.div>
  );
}

export default About;
